import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_app_page = _resolveComponent("app-page")!
  const _component_add_dialog = _resolveComponent("add-dialog")!
  const _component_EditDialog = _resolveComponent("EditDialog")!
  const _component_BulkDialog = _resolveComponent("BulkDialog")!
  const _component_ProjectNameEditDialog = _resolveComponent("ProjectNameEditDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_page, { fheader: { showCollapse: true } }, {
      fheader: _withCtx(({ collapse }) => [
        _createVNode(_component_el_form, {
          size: "default",
          ref: "queryForm",
          "label-width": "120px",
          model: _ctx.params,
          onKeyup: _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.handleSearch()), ["enter"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "项目名称",
              prop: "projectName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.params.projectName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.projectName) = $event)),
                  placeholder: "请输入项目名称",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "域名地址",
              prop: "domainName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.params.domainName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.domainName) = $event)),
                  placeholder: "请输入域名地址",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "服务类型",
              clearable: "",
              prop: "serviceType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.params.serviceType,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.serviceType) = $event)),
                  placeholder: "请选择服务类型",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.HANDLE_SERVICE_TYPE_LIST, (option) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: option.value,
                        label: option.label,
                        value: option.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            collapse
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "一级菜单",
                  prop: "firstLevelMenu"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "请输入一级菜单",
                      modelValue: _ctx.params.firstLevelMenu,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.firstLevelMenu) = $event)),
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            collapse
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: "二级菜单",
                  prop: "secondLevelMenu"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "请输入二级菜单",
                      modelValue: _ctx.params.secondLevelMenu,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.params.secondLevelMenu) = $event)),
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            collapse
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 2,
                  label: "后端服务",
                  prop: "serviceName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "请输入后端服务名称",
                      modelValue: _ctx.params.serviceName,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.params.serviceName) = $event)),
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, { "label-width": "40px" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleSearch()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 查询 ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, { onClick: _ctx.handleReset }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 重置 ")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1032, ["model"])
      ]),
      header: _withCtx(() => [
        (_ctx.$has(_ctx.permissionConfig.XZ))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              size: "default",
              onClick: _ctx.handleAddServiceDialog
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 新增 ")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.$has(_ctx.permissionConfig.PLBJ))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "primary",
              size: "default",
              onClick: _ctx.handleBulkEditDialog,
              disabled: _ctx.checkList.length < 1
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 批量编辑 ")
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]))
          : _createCommentVNode("", true)
      ]),
      main: _withCtx(({height}) => [
        (_openBlock(), _createBlock(_component_el_table, {
          key: _ctx.tableData,
          border: "",
          height: height,
          data: _ctx.tableData,
          onSelect: _ctx.handleSelect,
          onSelectAll: _ctx.handleSelectAll,
          onSelectionChange: _ctx.handleSelectionChange,
          ref: "tableRef",
          "tree-props": {children: 'children'},
          "row-key": _ctx.handleRowKey
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "selection",
              width: "44",
              align: "center",
              selectable: _ctx.selectable
            }, null, 8, ["selectable"]),
            _createVNode(_component_el_table_column, {
              prop: "projectName",
              label: "项目",
              "min-width": "110",
              align: "left",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx(({row}) => [
                _createElementVNode("span", null, _toDisplayString(row.projectName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "域名地址",
              "min-width": "160",
              align: "center",
              prop: "domainName"
            }, {
              default: _withCtx(({row}) => [
                _createElementVNode("span", null, _toDisplayString(row.domainName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "一级菜单",
              "min-width": "110",
              align: "center",
              prop: "firstLevelMenu"
            }, {
              default: _withCtx(({row}) => [
                _createElementVNode("span", null, _toDisplayString(row.firstLevelMenu), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "二级菜单",
              "min-width": "120",
              align: "center",
              prop: "secondLevelMenu"
            }, {
              default: _withCtx(({row}) => [
                _createElementVNode("span", null, _toDisplayString(row.secondLevelMenu), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "类型",
              "min-width": "110",
              align: "center"
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(_ctx.$filters.getEnumLabel(_ctx.HANDLE_SERVICE_TYPE_LIST,row.serviceType)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "后端服务",
              "min-width": "200",
              align: "center"
            }, {
              default: _withCtx(({row}) => [
                _createVNode(_component_el_button, {
                  link: "",
                  type: "text",
                  onClick: ($event: any) => (_ctx.handleSelectRow(row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.serviceName), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "后端第一负责人",
              "min-width": "130",
              align: "center"
            }, {
              default: _withCtx(({row}) => [
                (!row.hasOwnProperty('children') && row.firstHeadOfBackend !== '')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(`${row.firstHeadOfBackend}(${row.firstHeadOfBackendCode})`), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "后端备选负责人",
              "min-width": "130",
              align: "center"
            }, {
              default: _withCtx(({row}) => [
                (!row.hasOwnProperty('children') && row.secondHeadOfBackend !== '')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(`${row.secondHeadOfBackend}(${row.secondHeadOfBackendCode})`), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "前端第一负责人",
              "min-width": "130",
              align: "center"
            }, {
              default: _withCtx(({row}) => [
                _createElementVNode("span", null, _toDisplayString(row.headOfDevelopment), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "前端备选负责人",
              "min-width": "130",
              align: "center"
            }, {
              default: _withCtx(({row}) => [
                _createElementVNode("span", null, _toDisplayString(row.secondHeadOfDevelopment), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "测试第一负责人",
              "min-width": "130",
              align: "center"
            }, {
              default: _withCtx(({row}) => [
                _createElementVNode("span", null, _toDisplayString(row.headOfTest), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "测试备选负责人",
              "min-width": "130",
              align: "center"
            }, {
              default: _withCtx(({row}) => [
                _createElementVNode("span", null, _toDisplayString(row.secondHeadOfTest), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "备注",
              "min-width": "130",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              "min-width": "220",
              align: "center",
              class: "column-flex"
            }, {
              default: _withCtx(({row}) => [
                (!row.hasOwnProperty('children') && _ctx.$has(_ctx.permissionConfig.BJ))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "text",
                      onClick: ($event: any) => (_ctx.handleEditDialog(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (row.hasOwnProperty('children') && _ctx.$has(_ctx.permissionConfig.BJ))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "text",
                      onClick: ($event: any) => (_ctx.handleProjectNameEditDialog(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1032, ["height", "data", "onSelect", "onSelectAll", "onSelectionChange", "row-key"]))
      ]),
      ffooter: _withCtx(() => [
        _createVNode(_component_el_row, {
          style: {"width":"100%"},
          type: "flex",
          justify: "end"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_pagination, {
              total: _ctx.tableTotal,
              "current-page": _ctx.params.pageNum,
              size: _ctx.params.pageSize,
              onCurrentChange: _ctx.handleCurrentChange,
              onSizeChange: _ctx.handleSizeChange
            }, null, 8, ["total", "current-page", "size", "onCurrentChange", "onSizeChange"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_add_dialog, {
      modelValue: _ctx.handleDddServiceDialogState.visible,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.handleDddServiceDialogState.visible) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_EditDialog, {
      modelValue: _ctx.handleEditDialogState.visible,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.handleEditDialogState.visible) = $event)),
      editData: _ctx.handleEditDialogState.editData,
      onSuccess: _ctx.handleOperation,
      onCancel: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleSearch()))
    }, null, 8, ["modelValue", "editData", "onSuccess"]),
    _createVNode(_component_BulkDialog, {
      modelValue: _ctx.handleBulkEditDialogState.visible,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.handleBulkEditDialogState.visible) = $event)),
      ids: _ctx.handleBulkEditDialogState.ids,
      onSuccess: _ctx.handleOperation
    }, null, 8, ["modelValue", "ids", "onSuccess"]),
    _createVNode(_component_ProjectNameEditDialog, {
      modelValue: _ctx.handleProjectNameEditDialogState.visible,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.handleProjectNameEditDialogState.visible) = $event)),
      projectNameInfo: _ctx.handleProjectNameEditDialogState.projectNameInfo,
      onSuccess: _ctx.handleOperation
    }, null, 8, ["modelValue", "projectNameInfo", "onSuccess"])
  ], 64))
}